import { ID, WoosatTelecomResponse } from '../../../../../_metronic/helpers'

export type HawalaBranch = {
  id?: ID
  name?: string
  email?: string
  password?: string
  address?: string
  phone_number?: string
  commission_type?: 'percentage' | 'fixed'
  amount?: number
  status?: 'active' | 'inactive'
  created_at?: string
  updated_at?: string
}

export type HawalaBranchesQueryResponse = WoosatTelecomResponse<HawalaBranch[]>

export const initialHawalaBranch: HawalaBranch = {
  id: '',
  name: '',
  email: '',
  password: '',
  address: '',
  phone_number: '',
  commission_type: 'percentage',
  amount: 0,
  status: 'active',
}
